var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('Header',{attrs:{"header":_vm.$t('PAGE_NOT_FOUND')}}),_c('div',{staticClass:"mt-5 text-center"},[_c('b-btn',{attrs:{"variant":"secondary","size":"md","to":"/","exact":""}},[_vm._v(_vm._s(_vm.$t('GO_TO_DASHBOARD')))])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }